import React, { Component } from 'react';
import Link from 'gatsby-link';
import styled from 'styled-components/macro';
import { StaticImage } from 'gatsby-plugin-image';

import BusinessIcon from '../assets/img/BusinessIcon.svg';
import HomeLifeIcon from '../assets/img/HomeLifeIcon.svg';
import GogetterIcon from '../assets/img/GogetterIcon.svg';

import Divider from '@material-ui/core/Divider';

import fontSize from '../assets/fontSize';
import colors from '../assets/colors';

const AppStoreDownload = '../views/shared/DownloadUs/assets/app-store.png';
const PlayStoreDownload = '../views/shared/DownloadUs/assets/google-play.png';
const FacebookIcon = '../assets/img/FacebookIcon.png';
const InstaIcon = '../assets/img/InstaIcon.png';
const LinkedInIcon = '../assets/img/linkedin-icon.png';
const LogoIcon = '../assets/img/black_logo.png';

const Container = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding-top: ${props => !props.mobile && '2rem'};
  padding-bottom: 2rem;
  padding-left: 1rem;
  padding-right: 2rem;
  display: flex;
  justify-content: center;
  flex-direction: ${props => props.mobile && 'column'};
  position: relative;
  bottom: 0;
  left: 0;
  right: 0;
  @media (max-width: 730px) {
    padding-top: 22px;
  }
`;
const LogoWrapper = styled.div`
  margin-right: 2rem;
  margin-bottom: ${props => props.mobile && '1rem'};
  @media (max-width: 880px) {
    display: none;
  }
  @media (max-width: 730px) {
    display: block;
  }
`;
const LogoWrap = styled.div`
  width: ${props => (props.mobile ? '150px' : '160px')};
`;
const CategoryWrapper = styled.div`
  width: ${props => (props.mobile ? 'calc(100% - 2rem)' : '200px')};
  margin-bottom: ${props => props.mobile && '2rem'};
`;
const FlexDiv = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
`;
const CategoryIcon = styled.img`
  height: ${props => (props.mobile ? '24px' : '36px')};
  margin-right: ${props => (props.mobile ? '0.5rem' : '1rem')};
`;
const Title = styled.div`
  font-family: 'Open Sans', sans-serif !important;
  font-family: Open Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: ${props => props.marginBottom && '1rem'};
`;
const LinkWrapper = styled.div`
  display: flex;
  flex-direction: ${props => !props.mobile && 'column'};
`;
const LinkDiv = styled.div`
  width: ${props => (props.mobile ? '50%' : '100%')};
  margin-right: ${props => props.mobile && '0.5rem'};
  display: flex;
  flex-direction: column;
  align-items: start;
`;
const StyledLink = styled(Link)`
  color: ${colors.black};
  text-decoration: none;
  font-size: ${props =>
    props.mobile ? `${fontSize.large}` : `${fontSize.xLarge}`};
  line-height: 1.5rem;
  // margin-bottom: 1rem;
`;
const ButtonWrap = styled.div``;
const DownloadButtonsWrap = styled.div`
  display: flex;
  flex-direction: ${props => !props.mobile && 'column'};
  margin-bottom: 1rem;
`;
const DownloadButtonImgWrap = styled.div`
  width: ${props => (props.mobile ? '120px' : '160px')};
  margin-bottom: 0.5rem;
  margin-right: ${props => props.mobile && '1rem'};
`;
const SocialButtonsWrap = styled.div`
  display: flex;
`;
const SocialMediaIconWrap = styled.div`
  width: 38px;
  margin-right: 28px;
`;
const CopyrightText = styled.div`
  font-family: 'Open Sans', sans-serif !important;
  font-size: ${fontSize.medium};
  font-weight: normal;
  line-height: 16px;
  display: flex;
  justify-content: flex-end;
  flex: 1;
`;
const StyledButton = styled.div`
  margin-bottom: 1rem;
  padding-left: 0;
  font-family: 'Open Sans', sans-serif;
  text-transform: capitalize;
  font-size: 14px;
  font-weight: normal;
  line-height: 16px;
  min-width: unset;
`;
const FooterDiv = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  margin-top: 1rem;
  margin-bottom: 1rem;
  margin-left: auto;
  margin-right: auto;
  width: 93%;
  @media (max-width: 730px) {
    flex-direction: column;
    margin-bottom: ${props => props.isShowingFooterAppBar && '6rem'};
  }
`;
const FooterTextWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  @media (max-width: 730px) {
    margin-bottom: 1rem;
  }
`;
const PrivacyText = styled(Link)`
  color: ${colors.black};
  font-family: 'Open Sans', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: ${fontSize.large};
  line-height: 16px;
  text-decoration: none;
`;
const Bullet = styled.span`
  margin-left: 21px;
  margin-right: 21px;
`;

class Footer extends Component {
  state = {
    mobile: undefined
  };

  updateWindowDimensions = () => {
    const { mobile } = this.state;
    if (window.innerWidth <= 730 && !mobile) {
      this.setState({ mobile: true });
    } else if (window.innerWidth > 730 && mobile) {
      this.setState({ mobile: false });
    }
  };

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  render() {
    const { mobile } = this.state;
    const {
      hideFooterDownloadButtons,
      hideDownloadGoGetter,
      hideDownloadPoster,
      isShowingFooterAppBar
    } = this.props;

    const renderBusinessFAQ = (
      <StyledButton>
        <StyledLink
          to="/business"
          mobile={mobile}
          onClick={() => {
            window.analytics.track('footer_clickthrough', {
              category: 'clickthrough',
              label: 'FAQs',
              destination: '/business',
              platform: 'static'
            });
          }}
        >
          FAQs
        </StyledLink>
      </StyledButton>
    );
    return (
      <footer className="container mx-auto py-16 px-3 mt-48 mb-8 text-gray-800">
        <Container mobile={mobile}>
          <LogoWrapper mobile={mobile}>
            <StyledLink to="/" mobile={mobile}>
              <LogoWrap mobile={mobile}>
                <StaticImage src={LogoIcon} placeholder="blurred" alt="GoGet" />
              </LogoWrap>
            </StyledLink>
          </LogoWrapper>
          <CategoryWrapper mobile={mobile}>
            <StyledLink
              to="/business"
              mobile={mobile}
              onClick={() => {
                window.analytics.track('footer_clickthrough', {
                  category: 'clickthrough',
                  label: 'Business',
                  destination: '/business',
                  platform: 'static'
                });
              }}
            >
              <FlexDiv>
                <CategoryIcon src={BusinessIcon} alt="" mobile={mobile} />
                <Title mobile={mobile}>Business</Title>
              </FlexDiv>
            </StyledLink>
            <LinkWrapper mobile={mobile}>
              <LinkDiv mobile={mobile}>
                <StyledButton>
                  <StyledLink
                    to="/business/projects"
                    mobile={mobile}
                    onClick={() => {
                      window.analytics.track('footer_clickthrough', {
                        category: 'clickthrough',
                        label: 'Pricing',
                        destination: '/business/projects',
                        platform: 'static'
                      });
                    }}
                  >
                    GoGet Projects
                  </StyledLink>
                </StyledButton>
                <StyledButton>
                  <StyledLink
                    to="/business/pricing"
                    mobile={mobile}
                    onClick={() => {
                      window.analytics.track('footer_clickthrough', {
                        category: 'clickthrough',
                        label: 'Pricing',
                        destination: '/business/pricing',
                        platform: 'static'
                      });
                    }}
                  >
                    Pricing
                  </StyledLink>
                </StyledButton>
                <StyledButton>
                  <StyledLink
                    to="/business"
                    mobile={mobile}
                    onClick={() => {
                      window.analytics.track('footer_clickthrough', {
                        category: 'clickthrough',
                        label: 'Case Studies',
                        destination: '/business',
                        platform: 'static'
                      });
                    }}
                  >
                    Case Studies
                  </StyledLink>
                </StyledButton>
                {mobile && renderBusinessFAQ}
              </LinkDiv>
              <LinkDiv mobile={mobile}>
                <StyledButton>
                  <StyledLink
                    to="/business"
                    mobile={mobile}
                    onClick={() => {
                      window.analytics.track('footer_clickthrough', {
                        category: 'clickthrough',
                        label: 'Service Categories',
                        destination: '/business',
                        platform: 'static'
                      });
                    }}
                  >
                    Service Categories
                  </StyledLink>
                </StyledButton>
                <StyledButton>
                  <StyledLink
                    to="/api"
                    mobile={mobile}
                    onClick={() => {
                      window.analytics.track('footer_clickthrough', {
                        category: 'clickthrough',
                        label: 'API Integration',
                        destination: '/api',
                        platform: 'static'
                      });
                    }}
                  >
                    API Integration
                  </StyledLink>
                </StyledButton>
                {!mobile && renderBusinessFAQ}
              </LinkDiv>
            </LinkWrapper>
          </CategoryWrapper>

          <CategoryWrapper mobile={mobile}>
            <StyledLink
              to="/homelife"
              mobile={mobile}
              onClick={() => {
                window.analytics.track('footer_clickthrough', {
                  category: 'clickthrough',
                  label: 'Home & Life',
                  destination: '/homelife',
                  platform: 'static'
                });
              }}
            >
              <FlexDiv>
                <CategoryIcon src={HomeLifeIcon} alt="" mobile={mobile} />
                <Title mobile={mobile}>Home & Life</Title>
              </FlexDiv>
            </StyledLink>
            <LinkWrapper mobile={mobile}>
              <LinkDiv mobile={mobile}>
                <StyledButton>
                  <StyledLink
                    to="/homelife/pricing"
                    mobile={mobile}
                    onClick={() => {
                      window.analytics.track('footer_clickthrough', {
                        category: 'clickthrough',
                        label: 'Pricing',
                        destination: '/homelife/pricing',
                        platform: 'static'
                      });
                    }}
                  >
                    Pricing
                  </StyledLink>
                </StyledButton>
                <StyledButton>
                  <StyledLink
                    to="/homelife"
                    mobile={mobile}
                    onClick={() => {
                      window.analytics.track('footer_clickthrough', {
                        category: 'clickthrough',
                        label: 'Service Categories',
                        destination: '/homelife',
                        platform: 'static'
                      });
                    }}
                  >
                    Service Categories
                  </StyledLink>
                </StyledButton>
              </LinkDiv>
              <LinkDiv mobile={mobile}>
                <StyledButton>
                  <StyledLink
                    to="/homelife"
                    mobile={mobile}
                    onClick={() => {
                      window.analytics.track('footer_clickthrough', {
                        category: 'clickthrough',
                        label: 'How It Works',
                        destination: '/homelife',
                        platform: 'static'
                      });
                    }}
                  >
                    How It Works
                  </StyledLink>
                </StyledButton>
                <StyledButton>
                  <StyledLink
                    to="/homelife"
                    mobile={mobile}
                    onClick={() => {
                      window.analytics.track('footer_clickthrough', {
                        category: 'clickthrough',
                        label: 'FAQs',
                        destination: '/homelife',
                        platform: 'static'
                      });
                    }}
                  >
                    FAQs
                  </StyledLink>
                </StyledButton>
              </LinkDiv>
            </LinkWrapper>
          </CategoryWrapper>

          <CategoryWrapper mobile={mobile}>
            <StyledLink
              to="/gogetters"
              mobile={mobile}
              onClick={() => {
                window.analytics.track('footer_clickthrough', {
                  category: 'clickthrough',
                  label: 'GoGetters',
                  destination: '/gogetters',
                  platform: 'static'
                });
              }}
            >
              <FlexDiv>
                <CategoryIcon src={GogetterIcon} alt="" mobile={mobile} />
                <Title mobile={mobile}>GoGetters</Title>
              </FlexDiv>
            </StyledLink>
            <LinkWrapper mobile={mobile}>
              <LinkDiv mobile={mobile}>
                <StyledButton>
                  <StyledLink
                    to="/gogetters"
                    mobile={mobile}
                    onClick={() => {
                      window.analytics.track('footer_clickthrough', {
                        category: 'clickthrough',
                        label: 'Be A GoGetter',
                        destination: '/gogetters',
                        platform: 'static'
                      });
                    }}
                  >
                    Be A GoGetter
                  </StyledLink>
                </StyledButton>
                <StyledButton>
                  <StyledLink
                    to="/community"
                    mobile={mobile}
                    onClick={() => {
                      window.analytics.track('footer_clickthrough', {
                        category: 'clickthrough',
                        label: 'Meet our community',
                        destination: '/community',
                        platform: 'static'
                      });
                    }}
                  >
                    Meet our community
                  </StyledLink>
                </StyledButton>
              </LinkDiv>
              <LinkDiv mobile={mobile}>
                <StyledButton>
                  <StyledLink
                    to="/gogetters"
                    mobile={mobile}
                    onClick={() => {
                      window.analytics.track('footer_clickthrough', {
                        category: 'clickthrough',
                        label: 'FAQs',
                        destination: '/gogetters',
                        platform: 'static'
                      });
                    }}
                  >
                    FAQs
                  </StyledLink>
                </StyledButton>
              </LinkDiv>
            </LinkWrapper>
          </CategoryWrapper>
          <CategoryWrapper mobile={mobile}>
            <LinkWrapper style={{ marginTop: 8 }}>
              <LinkDiv>
                <FlexDiv>
                  <Title mobile={mobile}>Company</Title>
                </FlexDiv>
              </LinkDiv>
            </LinkWrapper>
            <LinkWrapper mobile={mobile}>
              <LinkDiv mobile={mobile}>
                <StyledButton>
                  <StyledLink
                    to="/careers"
                    mobile={mobile}
                    onClick={() => {
                      window.analytics.track('footer_clickthrough', {
                        category: 'clickthrough',
                        label: 'careers',
                        destination: '/careers',
                        platform: 'static'
                      });
                    }}
                  >
                    Careers
                  </StyledLink>
                </StyledButton>
                <StyledButton>
                  <StyledLink
                    to="/blog"
                    mobile={mobile}
                    onClick={() => {
                      window.analytics.track('footer_clickthrough', {
                        category: 'clickthrough',
                        label: 'blog',
                        destination: '/blog',
                        platform: 'static'
                      });
                    }}
                  >
                    Blog
                  </StyledLink>
                </StyledButton>
                <StyledButton>
                  <StyledLink
                    href="https://www.photobook.com.my/goget"
                    target="_blank"
                    rel="noreferrer noopener"
                    mobile={mobile}
                  >
                    Merchandise
                  </StyledLink>
                </StyledButton>
              </LinkDiv>
            </LinkWrapper>
          </CategoryWrapper>
          {!hideFooterDownloadButtons && (
            <ButtonWrap>
              {!hideDownloadPoster && (
                <div>
                  <Title marginBottom style={{ marginTop: 8 }}>
                    Create Job
                  </Title>
                  <DownloadButtonsWrap mobile={mobile}>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.goget&hl=en"
                      onClick={() => {
                        window.analytics.track('customer_app_download', {
                          category: 'android',
                          label: 'footer'
                        });
                      }}
                    >
                      <DownloadButtonImgWrap mobile={mobile}>
                        <StaticImage
                          src={PlayStoreDownload}
                          placeholder="blurred"
                          alt="Download GoGetter app from Google Play Store"
                        />
                      </DownloadButtonImgWrap>
                    </a>
                    <a
                      href="https://apps.apple.com/my/app/goget-hire-on-demand/id1033297708"
                      onClick={() => {
                        window.analytics.track('customer_app_download', {
                          category: 'ios',
                          label: 'footer'
                        });
                      }}
                    >
                      <DownloadButtonImgWrap mobile={mobile}>
                        <StaticImage
                          src={AppStoreDownload}
                          alt="Download GoGet app from AppStore"
                        />
                      </DownloadButtonImgWrap>
                    </a>
                  </DownloadButtonsWrap>
                </div>
              )}
              {!hideDownloadGoGetter && (
                <div>
                  <Title marginBottom style={{ marginTop: 8 }}>
                    Be a Part Timer
                  </Title>
                  <DownloadButtonsWrap mobile={mobile}>
                    <a
                      href="https://play.google.com/store/apps/details?id=my.goget.gogetter&hl=en"
                      onClick={() => {
                        window.analytics.track('gogetter_app_download', {
                          category: 'android',
                          label: 'footer'
                        });
                      }}
                    >
                      <DownloadButtonImgWrap mobile={mobile}>
                        <StaticImage
                          src={PlayStoreDownload}
                          placeholder="blurred"
                          alt="Download GoGetter app from Google Play Store"
                        />
                      </DownloadButtonImgWrap>
                    </a>
                    <a
                      href="https://apps.apple.com/my/app/gogetter-part-timer-community/id1483160371"
                      onClick={() => {
                        window.analytics.track('gogetter_app_download', {
                          category: 'ios',
                          label: 'footer'
                        });
                      }}
                    >
                      <DownloadButtonImgWrap mobile={mobile}>
                        <StaticImage
                          src={AppStoreDownload}
                          alt="Download GoGet app from AppStore"
                        />
                      </DownloadButtonImgWrap>
                    </a>
                  </DownloadButtonsWrap>
                </div>
              )}
              <Title marginBottom>Follow us on</Title>
              <SocialButtonsWrap>
                <a href="https://www.instagram.com/gogetmy/?hl=en">
                  <SocialMediaIconWrap>
                    <StaticImage
                      src={InstaIcon}
                      placeholder="blurred"
                      alt="instagram icon"
                    />
                  </SocialMediaIconWrap>
                </a>
                <a href="https://www.facebook.com/GoGet.my/">
                  <SocialMediaIconWrap>
                    <StaticImage
                      src={FacebookIcon}
                      placeholder="blurred"
                      alt="facebook icon"
                    />
                  </SocialMediaIconWrap>
                </a>
                <a href="https://www.linkedin.com/company/goget-my">
                  <SocialMediaIconWrap>
                    <StaticImage
                      src={LinkedInIcon}
                      placeholder="blurred"
                      alt="linkedin icon"
                    />
                  </SocialMediaIconWrap>
                </a>
              </SocialButtonsWrap>
            </ButtonWrap>
          )}
        </Container>
        <Divider />
        <FooterDiv isShowingFooterAppBar={isShowingFooterAppBar}>
          <FooterTextWrapper>
            <PrivacyText to="/terms_conditions">Terms & Conditions</PrivacyText>
            <Bullet>&#8226;</Bullet>
            <PrivacyText to="/privacy_policy">Privacy Policy</PrivacyText>
          </FooterTextWrapper>
          <CopyrightText>
            &copy;{new Date().getFullYear()} GoGet.my. All rights reserved.
          </CopyrightText>
        </FooterDiv>
      </footer>
    );
  }
}

export default Footer;
